export default {
  name: 'Lato',
  weight: '700',
  style: 'normal',
  files: []
}
